<section class="content">
  <div class="content-block">
    <div class="row clearfix">
      <div class="col-lg-4 col-md-12">
        <div class="card">
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="card">


          <router-outlet></router-outlet>

        </div>
      </div>
    </div>
  </div>
</section>